import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const PROJECT_QUERY = gqlTagGira`
    query jira_cycleTimeReport_projectIssueTypes_Query($projectKey: String!) {
        project(projectKey: $projectKey) {            
            issueTypes {
                id
                name
                iconUrl
            }
        }
    }
`;
